import currency from 'currency.js';
import { VEDIC_FORMAT_CURRENCIES } from '../constants/format';

const config = {
    decimal: '.',
    separator: ',',
    symbol: '',
};

const formatToCurrency = (
    amount: number | string,
    currencyPrecision: number,
    currencyTemplate = 'X',
    currencyCode: string = null,
    removeTrailingZeroes = false,
): string => {
    let formattedValue = currency(amount, {
        ...config,
        precision: currencyPrecision,
        useVedic: VEDIC_FORMAT_CURRENCIES.includes(currencyCode),
    }).format();

    if (removeTrailingZeroes) {
        formattedValue = formattedValue.replace(/\.0+([^\d]*?)$/, '$1');
    }

    return currencyTemplate.replace('X', formattedValue);
};

export default formatToCurrency;
